import {
    AlterarSenhaService,
    CriarNovaSenhaService,
    doLoginOrganizacao,
    doLoginUsuario,
    EmailRecuperarSenhaService,
    ListarOrganizacaoService,
} from "../../Services/Login/LoginServices";

import {
    LoginOrganizacao,
    Login,
    TokenAccess,
} from "../../Interfaces/Login/LoginInterface";

import { Organizacao } from "../../Interfaces/Login/OrganizacaoInterface";
import { ValidationErr } from "../../Validations/ValidationError";
import { Controller } from "../Controller";

export async function LoginOrganizacaoController(user: LoginOrganizacao) {
    const ResponseLogin = await doLoginOrganizacao(user)
        .then((response: Array<Organizacao>) => {
            return response;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return ResponseLogin;
}

export async function LoginUser(user: Login) {
    const ResponseLogin = await doLoginUsuario(user)
        .then((response: TokenAccess) => {
            const token = response.Token;

            localStorage.setItem("@token", token);

            return token;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return ResponseLogin;
}

export async function ListarOrganizacaoController() {
    return Controller(ListarOrganizacaoService());
}

export async function EmailRecuperarSenhaController(email: string) {
    const ResponseLogin = await EmailRecuperarSenhaService(email)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return ResponseLogin;
}

export async function AlterarSenhaController(
    password: string,
    cPassword: string,
    token: string
) {
    const ResponseLogin = await AlterarSenhaService(password, cPassword, token)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return ResponseLogin;
}

export async function CriarNovaSenhaController(
    SenhaNova: string,
    token: string
) {
    return Controller(CriarNovaSenhaService(SenhaNova, token));
}
